// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorCommission = (client) => ({
    /**
     * `GET /vendor/commission`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListCommissionLines
     * @source packages/modules/commission/src/api/vendor/commission/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/commission", { method: "GET", query, headers }),
});
//# sourceMappingURL=commission.js.map